
const apiUrl = '/api';

export const createApiUrl = urn => {
  const { location } = window;
  return apiUrl + (urn || (location.pathname + location.search));
};
